import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, Stat } from "@/components/admin/common";
import { CardsTable } from "@/components/admin/CardsTable";
import { DailyChart } from "@/components/admin/TrafficChart";
import { NewCardDialog } from "@/components/admin/NewCardDialog";
import { api } from "@/lib/api";

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [cards, setCards] = useState([]);
  const [open, setOpen] = useState(false);
  const load = () => {
    api.get("/analytics/overview", { params: { days: 30 } }).then((r) => setStats(r.data));
    api.get("/cards").then((r) => setCards(r.data));
  };
  useEffect(() => {
    load();
  }, []);
  const t = stats?.totals || {};
  return (
    <div>
      <PageHeader eyebrow="Panoramica" title="Buongiorno." description="Lo stato delle digital card dei tuoi clienti negli ultimi 30 giorni.">
        <Button onClick={() => setOpen(true)} data-testid="create-card-button"><Plus className="mr-1.5 h-4 w-4" />Nuova card</Button>
      </PageHeader>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Stat label="Clienti attivi" value={stats?.counts.clients ?? "–"} testId="stat-clients" />
        <Stat label="Card pubblicate" value={stats ? `${stats.counts.published}/${stats.counts.cards}` : "–"} testId="stat-published" />
        <Stat label="Visite · 30gg" value={t.views ?? "–"} hint={t.views != null ? `${t.qr_views} da QR` : ""} testId="stat-views" />
        <Stat label="Click Salva contatto" value={t.vcard_downloads ?? "–"} hint="Download del file .vcf" testId="stat-vcard" />
      </div>
      <div className="panel mt-6 p-6">
        <div className="mb-4 flex items-center justify-between"><div className="eyebrow">Andamento giornaliero</div><Link to="/admin/statistiche" className="flex items-center gap-1 text-xs text-zinc-500 hover:text-terra">Statistiche<ArrowUpRight className="h-3 w-3" /></Link></div>
        {stats && <DailyChart data={stats.daily} />}
      </div>
      <div className="mt-10 mb-4 flex items-center justify-between"><h2 className="font-display text-3xl">Card recenti</h2><Link to="/admin/card" className="text-sm text-zinc-500 hover:text-terra" data-testid="dashboard-all-cards-link">Tutte le card →</Link></div>
      <CardsTable cards={cards.slice(0, 6)} onChanged={load} />
      <NewCardDialog open={open} onOpenChange={setOpen} />
    </div>
  );
}
